import { createAction } from '@reduxjs/toolkit';

import { WalletTypes, GlobalTypes, AppState } from '@modules';
import api from '@modules/api';
import { createAsyncActions, createActions } from '@modules/helpers';

const actions = createActions('wallet', {
  setFiatCurrencies: name => createAction<GlobalTypes.FiatCurrencyEnum[]>(name),
});

export const asyncActions = createAsyncActions('wallet', {
  getWallet: (data: WalletTypes.GETWalletParams, thunkApi) =>
    api.get<WalletTypes.GETWalletResponse>(thunkApi, '/wallet', { params: data }),

  getWalletPolling: (data: WalletTypes.GETWalletParams, thunkApi) =>
    api.get<WalletTypes.GETWalletResponse>(thunkApi, '/wallet', { params: data }),

  getWalletLimits: (data: WalletTypes.GETWalletLimitsParams, thunkApi) =>
    api.get<WalletTypes.GETWalletLimitsResponse>(thunkApi, '/wallet/limits', { params: data }),

  getWalletLimitsPolling: (data: WalletTypes.GETWalletLimitsParams, thunkApi) =>
    api.get<WalletTypes.GETWalletLimitsResponse>(thunkApi, '/wallet/limits', { params: data }),

  getRateForRateInformer: (data: WalletTypes.GETRateParams, thunkApi) =>
    api.get<WalletTypes.GETRateResponse>(thunkApi, '/rate', { params: data }),

  getTopupAddress: (currency: WalletTypes.GetTopupAddressParams['currency'], thunkApi) => {
    const params = { currency };
    return api.get<WalletTypes.GetTopupAddressResponse>(thunkApi, '/topup/address', { params });
  },

  getRapydPaymentMethods: (_: void, thunkApi) => {
    const state = thunkApi.getState() as AppState;
    const params = { country: state.user.data?.country_code };
    const url = '/wallet/rapyd/methods';
    return api.getGo<WalletTypes.GetRapydPaymentMethodsResponse>(thunkApi, url, { params });
  },
});

export default { ...actions, ...asyncActions };
